import React from 'react';
import { Reveal } from './Reveal';
import { comparison } from '../data/content';
export function Authority() {
  return <section id="autoridad" className="border-b border-white/10" aria-labelledby="authority-title" data-id="element-11" data-mp="3uobs5gf7w949">
      <div className="mx-auto max-w-6xl px-6 py-24 lg:py-28" data-id="element-12" data-mp="2iey5c45sxj3">
        <Reveal className="max-w-3xl" data-id="element-13" data-mp="7jvx323329x1">
          <p className="text-sm text-zinc-500" data-id="element-14" data-mp="7gq6tjipx1zq">Autoridad</p>
          <h2 id="authority-title" className="mt-5 text-3xl font-semibold leading-[1.1] tracking-[-0.02em] text-white sm:text-4xl" data-id="element-15" data-mp="cguqfiexacu6">
            Por qué confiar en un Growth Partner y no en una agencia.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-zinc-400" data-id="element-16" data-mp="ma36ytf0ykm4">
            Una agencia vende horas de gestión sobre tu inversión publicitaria.
            Su incentivo es que gastes más y que sigas contratada. Un Growth
            Partner entra en tus números: si tu contribución no crece, mi
            variable no existe. Trabajo con un máximo de cuatro marcas a la vez
            porque este nivel de implicación no es escalable en una hoja de
            Excel de clientes.
          </p>
        </Reveal>

        <Reveal delay={0.06} className="mt-14" data-id="element-17" data-mp="6etj6qpupav4">
          <div className="overflow-x-auto" data-id="element-18" data-mp="6fmtu2rxkkij">
            <table className="w-full min-w-[46rem] border-collapse text-left" data-id="element-19" data-mp="1g9x8qb9bz2r">
              <caption className="sr-only" data-id="element-20" data-mp="1icx0227p6ko">
                Comparativa entre una agencia tradicional y un Growth Partner
              </caption>
              <thead data-id="element-21" data-mp="u5qmxg7ht1va">
                <tr className="border-b border-white/20" data-id="element-22" data-mp="u57eqr7n9rug">
                  <th scope="col" className="w-1/4 py-4 pr-6 text-sm font-medium text-zinc-500" data-id="element-23" data-mp="pdflua10na15">
                    &nbsp;
                  </th>
                  <th scope="col" className="w-[37.5%] py-4 pr-6 text-sm font-medium text-zinc-500" data-id="element-24" data-mp="kem94jtjzn21">
                    Agencia tradicional
                  </th>
                  <th scope="col" className="w-[37.5%] py-4 text-sm font-medium text-accent" data-id="element-25" data-mp="1d39wckxv4mi8">
                    Growth Partner
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-26" data-mp="20z4xjrsq2gw9">
                {comparison.map(row => <tr key={row.dimension} className="border-b border-white/10 align-top" data-id="element-27" data-mp="1n7gm7qqarwgc">
                    <th scope="row" className="py-6 pr-6 text-sm font-medium text-white" data-id="element-28" data-mp="1n5npb35hkqlj">
                      {row.dimension}
                    </th>
                    <td className="py-6 pr-6 text-sm leading-relaxed text-zinc-500" data-id="element-29" data-mp="1i840xaf2qxfv">
                      {row.agency}
                    </td>
                    <td className="py-6 text-sm leading-relaxed text-zinc-200" data-id="element-30" data-mp="149xjt5ychc2w">
                      {row.partner}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-31" data-mp="32nyxvdotieb3">
          <blockquote className="mt-14 max-w-3xl border-l-2 border-accent pl-6" data-id="element-32" data-mp="32n7cevoxpwyj">
            <p className="font-serif text-2xl leading-snug text-white sm:text-3xl" data-id="element-33" data-mp="r0dn9hgq7rh6">
              «No me contratas para gestionar una cuenta de Meta. Me contratas
              para responder de tu MER, tu LTV y tu AOV como si el negocio fuera
              mío.»
            </p>
            <footer className="mt-5 text-sm text-zinc-500" data-id="element-34" data-mp="vzym7rvwbztw">
              Growth Euler — Growth Partner en suplementos y salud
            </footer>
          </blockquote>
        </Reveal>
      </div>
    </section>;
}